import React from 'react';
import { BriefcaseIcon, MonitorIcon, CheckCircleIcon } from 'lucide-react';
export function Services() {
  return <section id="services" className="py-24" style={{
    backgroundColor: '#F8F9FA'
  }} aria-labelledby="services-title" data-id="element-208">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-209">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-210">
          <p className="section-label" data-id="element-211">What We Do</p>
          <h2 id="services-title" className="section-title" data-id="element-212">
            Our Consulting Services
          </h2>
          <p className="text-[#6B6B6B] max-w-2xl mx-auto text-base leading-relaxed" data-id="element-213">
            We offer specialized consulting services tailored to the unique
            needs of entrepreneurs and businesses across the United States and
            Latin America.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-214">
          {/* Business Consulting Card */}
          <div className="bg-white rounded-2xl p-10 shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-100" data-id="element-215">
            <div className="mb-6" data-id="element-216">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-6" style={{
              backgroundColor: '#3A9A6A1A'
            }} data-id="element-217">
                <BriefcaseIcon size={32} color="#3A9A6A" aria-hidden="true" data-id="element-218" />
              </div>
              <h3 className="text-2xl font-bold text-[#3C3C3C] mb-3" data-id="element-219">
                Business Consulting
              </h3>
              <p className="text-[#6B6B6B] text-sm leading-relaxed mb-6" data-id="element-220">
                Strategic advisory services to help you structure, grow, and
                optimize your business operations.
              </p>
            </div>
            <ul className="space-y-4" role="list" data-id="element-221">
              <li className="flex items-start gap-3" data-id="element-222">
                <CheckCircleIcon size={20} color="#3A9A6A" className="flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-223" />
                <span className="text-[#3C3C3C] font-medium" data-id="element-224">
                  Business formation consulting
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-225">
                <CheckCircleIcon size={20} color="#3A9A6A" className="flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-226" />
                <span className="text-[#3C3C3C] font-medium" data-id="element-227">
                  Operational consulting
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-228">
                <CheckCircleIcon size={20} color="#3A9A6A" className="flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-229" />
                <span className="text-[#3C3C3C] font-medium" data-id="element-230">
                  Business structuring advisory
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-231">
                <CheckCircleIcon size={20} color="#3A9A6A" className="flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-232" />
                <span className="text-[#3C3C3C] font-medium" data-id="element-233">
                  Corporate consulting
                </span>
              </li>
            </ul>
          </div>

          {/* Technology Consulting Card */}
          <div className="bg-white rounded-2xl p-10 shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-100" data-id="element-234">
            <div className="mb-6" data-id="element-235">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-6" style={{
              backgroundColor: '#3A9A6A1A'
            }} data-id="element-236">
                <MonitorIcon size={32} color="#3A9A6A" aria-hidden="true" data-id="element-237" />
              </div>
              <h3 className="text-2xl font-bold text-[#3C3C3C] mb-3" data-id="element-238">
                Technology Consulting
              </h3>
              <p className="text-[#6B6B6B] text-sm leading-relaxed mb-6" data-id="element-239">
                Expert technology advisory to modernize your infrastructure,
                systems, and digital operations.
              </p>
            </div>
            <ul className="space-y-4" role="list" data-id="element-240">
              <li className="flex items-start gap-3" data-id="element-241">
                <CheckCircleIcon size={20} color="#3A9A6A" className="flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-242" />
                <span className="text-[#3C3C3C] font-medium" data-id="element-243">
                  Technology infrastructure consulting
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-244">
                <CheckCircleIcon size={20} color="#3A9A6A" className="flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-245" />
                <span className="text-[#3C3C3C] font-medium" data-id="element-246">
                  IT systems consulting
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-247">
                <CheckCircleIcon size={20} color="#3A9A6A" className="flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-248" />
                <span className="text-[#3C3C3C] font-medium" data-id="element-249">
                  Automation consulting
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-250">
                <CheckCircleIcon size={20} color="#3A9A6A" className="flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-251" />
                <span className="text-[#3C3C3C] font-medium" data-id="element-252">
                  Digital systems advisory
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}